import React, { useEffect, useState } from 'react'
import Icon from 'components/shared/Icon'
import cx from 'classnames'
import TealToolTip from 'components/TealToolTip'
import Truncate from 'react-truncate'

const capitalize = (str) => str[0].toUpperCase() + str.slice(1)

const FacetOption = ({
  parameterName,
  name,
  value,
  selected,
  handleFacetOptionClick
}) => {
  const [checkBoxSelected, setCheckBoxSelected] = useState(selected)

  useEffect(() => {
    setCheckBoxSelected(selected)
  }, [selected])

  const handleOnClick = () => {
    const selected = !checkBoxSelected
    setCheckBoxSelected(selected)
    handleFacetOptionClick(parameterName, value, selected)
  }

  return (
    <Link
      {...{
        href: null,
        label: name.replace('_', ', '),
        checkboxValue: (checkBoxSelected | 0) * 2,
        onClick: handleOnClick
      }}
    />
  )
}

export default FacetOption

const Link = ({ href, checkboxValue, label, onClick }) => {
  const [clamped, setClamped] = useState(false)

  return (
    <TealToolTip title={clamped ? label : ''} placement='right'>
      <div {...{ onClick }}>
        <a
          className='flex items-center w-100 filter-link black no-underline focus-outline-0 mt2 f6 pointer'
          {...{ href }}
          data-event-category='Search'
          data-event-action={checkboxValue > 0 ? 'Add Filter' : 'Remove Filter'}
          data-event-label={label}
        >
          <Icon
            className={cx('filter-checkbox-icon mr4', { 'dark-sea-green-3': checkboxValue === 2 })}
            name={{
              'icon-checkbox-blank-thin-outline': checkboxValue === 0,
              'icon-checkbox-marked': checkboxValue === 2
            }}
          />
          <Truncate
            trimWhitespace
            width={192}
            onTruncate={(isClamped) => setClamped(isClamped)}
          >
            {capitalize(label)}
          </Truncate>
        </a>
      </div>
    </TealToolTip>
  )
}
